import OpenLinkSvg from 'assets/icons/OpenLinkOutlined.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(OpenLinkSvg, { displayName: 'OpenLinkOutlined' });
